import React from 'react';
import './PayPalButton.scss';

/**
 * Botón nativo del SDK de PayPal v6. Copia de
 * containers/Payment/PayPal/screens/components/PayPalButton.js.
 *
 * REGLA CRÍTICA: saveSession.start() debe ejecutarse SIN await previo dentro
 * del click handler para preservar el transient activation del usuario — si hay
 * un await antes, el navegador bloquea el popup de PayPal.
 */

const resolveBorderRadius = shape => {
  if (shape === 'pill') return `80px`;
  if (shape === 'sharp') return '0px';
  return '4px'; // rect
};

export const PayPalButton = ({
  saveSessionRef,
  onSetupToken,
  disabled,
  buttonStyle = {},
  onError,
}) => {
  const {
    color = 'gold',
    shape = 'pill',
    label = 'paypal',
    height = 40,
    tagline = false,
  } = buttonStyle;
  const borderRadius = resolveBorderRadius(shape);

  const handleClick = () => {
    if (!saveSessionRef?.current) return;

    // Construir la promesa del setup-token de forma lazy — el SDK la resuelve
    // internamente justo antes de abrir el popup, no en el momento del click.
    const setupTokenPromise = onSetupToken()
      .then(vaultSetupToken => ({ vaultSetupToken }))
      .catch(() => onError?.());

    // SIN await — crítico para que el navegador no bloquee el popup
    saveSessionRef.current
      .start({ presentationMode: 'auto' }, setupTokenPromise)
      .catch(() => {});
  };

  return (
    <button
      className={`paypal-button${disabled ? ' paypal-button--disabled' : ''}`}
      onClick={handleClick}
      disabled={disabled}
      aria-label="Pagar con PayPal"
      type="button"
      style={{ height: `${height}px` }}
    >
      <paypal-button
        color={color}
        shape={shape}
        label={label}
        tagline={String(tagline)}
        style={{ '--paypal-button-border-radius': borderRadius }}
      />
    </button>
  );
};

export default PayPalButton;
